var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chat_14_",
    "data-name": "chat (14)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.219,
    height: 21.006,
    viewBox: "0 0 23.219 21.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#000000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_16",
    "data-name": "Path 16",
    d: "M132.235,150.4a.457.457,0,1,0-.457.457A.457.457,0,0,0,132.235,150.4Z",
    transform: "translate(-125.365 -144.248)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.457,
    cy: 0.457,
    rx: 0.457,
    ry: 0.457,
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 7.722, 5.774)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 0.457,
    cy: 0.457,
    rx: 0.457,
    ry: 0.457,
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 9.558, 5.774)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_17",
    "data-name": "Path 17",
    d: "M22.879,38.239a.34.34,0,0,0,.34-.34V32.058a1.4,1.4,0,0,0-1.4-1.4H16.5V25.789a1.4,1.4,0,0,0-1.4-1.4H4.875a.34.34,0,1,0,0,.68H15.1a.718.718,0,0,1,.717.717V35.3a.718.718,0,0,1-.717.717H5.807a.629.629,0,0,0-.419.159L2.9,38.387V36.644a.63.63,0,0,0-.63-.63H1.4A.718.718,0,0,1,.68,35.3V25.789a.718.718,0,0,1,.717-.717H3.286a.34.34,0,1,0,0-.68H1.4a1.4,1.4,0,0,0-1.4,1.4V35.3a1.4,1.4,0,0,0,1.4,1.4h.824V38.5a.623.623,0,0,0,.372.575.634.634,0,0,0,.26.056.624.624,0,0,0,.416-.161l2.556-2.275h.9v4.871a1.4,1.4,0,0,0,1.4,1.4h9.273l2.556,2.275a.624.624,0,0,0,.416.161.635.635,0,0,0,.26-.056A.622.622,0,0,0,21,44.767V42.962h.824a1.4,1.4,0,0,0,1.4-1.4V39.478a.34.34,0,0,0-.68,0v2.086a.718.718,0,0,1-.717.717h-.875a.63.63,0,0,0-.63.63v1.743L17.83,42.442a.629.629,0,0,0-.419-.159H8.119a.718.718,0,0,1-.717-.717V36.694h7.7a1.4,1.4,0,0,0,1.4-1.4V31.34h5.324a.718.718,0,0,1,.717.717V37.9a.34.34,0,0,0,.34.34Z",
    transform: "translate(0 -24.392)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ff35935667d264b34966f3e351e29fcb.svg";
export { ForwardRef as ReactComponent };